import Button, { SubmitButton } from "./Button";
import CollapseButton from "./collapse/CollapseButton";

const buttonTypes = {
  baseButton: Button,
  collapse: CollapseButton,
  SubmitButton
};

export default buttonTypes;
